import React, { PureComponent } from "react";
import FieldContainer from "../components/FieldContainer";
import TextareaAutoSize from "react-autosize-textarea";

export default class TextareaField extends PureComponent {
  render() {
    const { label, id, name, value = "", placeholder, onChange, required = false } = this.props;
    return (
      <FieldContainer {...this.props}>
        <TextareaAutoSize
          id={id}
          rows={1}
          name={name}
          placeholder={placeholder || label}
          value={value}
          required={required}
          className="af-textarea-field"
          onChange={e => onChange(name, e.target.value)}
        />
      </FieldContainer>
    );
  }
}
